__webpack_require__.p = "/react-pizza-typescript/";